import "./modules/common";
import { TabSelector, TabItem, TabbedLayout } from "spiritweb.packages.web-account";
import VueApp from "~/Scripts/new/vueApp";
import PublicationSearch from "~/Components/Search/PublicationSearch.vue";

new VueApp( {
  name: "PublicationArea",
  components: {
    PublicationSearch,
    TabSelector,
    TabItem,
    TabbedLayout,
  },
  data () {
    return {
      publicationResultCount: 0,
    };
  },
  computed: {
    uiPublicationCount () {
      const isSingular = this.publicationResultCount === 1;
      return `${this.publicationResultCount} publication${isSingular ? "" : "s"} found`;
    },
  },
  methods: {
    scrollPublicationsInView () {
      this.$refs.publicationSearch?.scrollIntoView( {
        behavior: "smooth",
        block: "start",
      } );
    },
    onUpdate ( resultCount ) {
      if ( window.location.href.includes( "#search" ) ) {
        // hack: ensure content has rendered before scrolling by executing last on the stack
        // mounted, next tick, DOMContentLoaded and custom ResizeObservers were not sufficient
        setTimeout( () => {
          this.scrollPublicationsInView();
        }, 10 );
      }
      this.setPublicationResultCount( resultCount );
    },
    setPublicationResultCount ( value ) {
      this.publicationResultCount = value;
    },
  },
} );
